<!-- components/icons/ChatRobotIcon.vue -->
<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="chat-robot-icon"
  >
    <!-- همون کد SVG که دادم -->
    <path
      d="M25 25h50v40H25z"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="35" cy="15" r="5" stroke="currentColor" stroke-width="4" />
    <circle cx="65" cy="15" r="5" stroke="currentColor" stroke-width="4" />
    <line
      x1="35"
      y1="20"
      x2="35"
      y2="25"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <line
      x1="65"
      y1="20"
      x2="65"
      y2="25"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M20 40c-8 0 -8 20 0 20"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M80 40c8 0 8 20 0 20"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M35 45h10"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M55 45h10"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M35 55c5 10 20 10 25 0"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
    />
    <path
      d="M15 70c-10 0 -10 15 0 15h15l-10 15v-15h20v-15z"
      stroke="currentColor"
      stroke-width="4"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "ChatRobotIcon",
};
</script>

<style scoped>
.chat-robot-icon {
  width: 24px;
  height: 24px;
  color: inherit;
}
</style>
